import { render, staticRenderFns } from "./GuiasYPersonal.vue?vue&type=template&id=2995cb78&"
import script from "./GuiasYPersonal.vue?vue&type=script&lang=js&"
export * from "./GuiasYPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports